import { render, staticRenderFns } from "./ContactNotes.vue?vue&type=template&id=518b52e4&scoped=true&"
import script from "./ContactNotes.vue?vue&type=script&lang=js&"
export * from "./ContactNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b52e4",
  null
  
)

export default component.exports